export default __webpack_public_path__ + "static/base-cloud-4641532e36b75dec1cd86f98ca8d8c7d.svg";